import { render, staticRenderFns } from "./ProductFormModal.vue?vue&type=template&id=3fd784ba&scoped=true"
import script from "./ProductFormModal.vue?vue&type=script&lang=js"
export * from "./ProductFormModal.vue?vue&type=script&lang=js"
import style0 from "./ProductFormModal.vue?vue&type=style&index=0&id=3fd784ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd784ba",
  null
  
)

export default component.exports